module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h2>Patients</h2>\r\n<div id="patients-container" class="top-margined">\r\n\r\n    <!--Filters-->\r\n    <div class="filters">\r\n        <div class="form-inline form">\r\n            <div class="form-group">\r\n                <input type="text"  class="form-control" id="patient-name" placeholder="Patient Name"\r\n                ';
 if (getParam('like_name')) { 
__p+=' value="'+
((__t=( getParam('like_name') ))==null?'':__t)+
'"  ';
 } 
__p+='\r\n                />\r\n            </div>\r\n            <div class="input-daterange input-group form-group" id="burn-range" style="width:280px;">\r\n                <input type="text" class="form-control" id="burn-after" placeholder="Born After" style="width:130px;"\r\n                ';
 if (getDateParam('object_birthData_from')){ 
__p+=' value="'+
((__t=( getDateParam('object_birthData_from') ))==null?'':__t)+
'"  ';
 } 
__p+='\r\n                />\r\n                <span class="input-group-addon">to</span>\r\n                <input type="text" class="form-control" id="burn-before" placeholder="Born Before" style="width:130px;"\r\n                ';
 if (getDateParam('object_birthData_to')){ 
__p+=' value="'+
((__t=( getDateParam('object_birthData_to') ))==null?'':__t)+
'"  ';
 } 
__p+='\r\n                />\r\n            </div>\r\n            &nbsp;OR&nbsp;\r\n            <div class="form-group">\r\n                <input type="text"  class="form-control" id="birth-date" placeholder="Birth Date"\r\n                ';
 if (getDateParam('object_birthData_date')){ 
__p+=' value="'+
((__t=( getDateParam('object_birthData_date') ))==null?'':__t)+
'"  ';
 } 
__p+='\r\n                />\r\n            </div>\r\n            <div class="form-group">\r\n                <button class="btn btn-primary" id="filter">Filter</button>\r\n            </div>\r\n            <div class="form-group">\r\n                <button class="btn btn-primary" title="Reset filter" id="clear-filter">Clear filter</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <!--<div class="loading"></div>-->\r\n    <table class="table table-hover">\r\n        <thead>\r\n        <tr>\r\n            <th>Patient</th>\r\n            <th>Age</th>\r\n        </tr>\r\n        </thead>\r\n        <tbody></tbody>\r\n    </table>\r\n\r\n    <div id="pager"></div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/patients/patients-view.html
// module id = 462
// module chunks = 0